import React from "react";
import { useFooterLayouts } from "../../../hooks/apis/main";

function Contact_ways() {

    const { data, isLoading, error } = useFooterLayouts();

    if (isLoading) return <div className="active loading position-fixed">
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
    </div>;

    if (error) return <p>Error</p>;
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="contact-ways">
                        <div className="row">
                            <div className="col-lg-4 col-12">
                                <div className="way">
                                    <i className="fas fa-mail-bulk icon"></i>
                                    <p className="title">
                                        <span>ایمیل</span>
                                        <a className="link" href={`mailto:${data.contact_infos[0].value}`}>{data.contact_infos[0].value}</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-12">
                                <div className="way">
                                    <i className="fas fa-phone icon"></i>
                                    <p className="title">
                                        <span>شماره تماس</span>
                                        <a className="link" href={`tel:${data.contact_infos[1].value}`}>{data.contact_infos[1].value}</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-12">
                                <div className="way">
                                    <i className="fas fa-map-marker-alt icon"></i>
                                    <p className="title">
                                        <span>آدرس</span>
                                        <a className="link">{data.contact_infos[2].value}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Contact_ways;